
  export const style={
    inpuStyle:{
      colorInput:"#37393F"
    },
    url:{
      urlClient:"https://feimimodainverno.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_feimi.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"Noz/Nozes"
    },
    teamName:{
      name:"Feimi"
    },
    hasToken: false,
    hostHeader: "feimi"
  }
